require('./lbaBreadCrumb.scss');

const $inject = [];

const lbaBreadCrumb = function () {
  return {
    restrict: 'E',
    scope: {},
    bindToController: true,
    controller: 'lbaBreadCrumbCtrl',
    controllerAs: 'vm',
    template: require('./lbaBreadCrumb.html')
  }
};

lbaBreadCrumb.$inject = $inject;

export default lbaBreadCrumb;



// WEBPACK FOOTER //
// ./src/components/lbaBreadCrumb/lbaBreadCrumbDir.js